module.exports = __webpack_public_path__ + "static/media/offer_ar.766a4319.png";